import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  fetchPosts,
  likePost,
  createPost,
  updateNewPost,
} from "../../redux/actions/blogActions";
import { RootState, AppDispatch } from "../../redux/store"; // Import correct dispatch type
import { FaThumbsUp, FaComment, FaPlus, FaTimes } from "react-icons/fa";
import "./Blogs.css";

const Blogs: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>(); // Corrected dispatch type
  const { posts, loading, error, newPost } = useSelector(
    (state: RootState) => state.blog
  );

  const cognito_user_id_current = "4d7a4f4c-e5b9-4781-8c39-0990053e8888";
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [mediaFiles, setMediaFiles] = useState<File[]>([]);

  useEffect(() => {
    dispatch(fetchPosts());
  }, [dispatch]);

  const refreshPosts = async () => {
    await dispatch(fetchPosts());
  };

  const handleLikePost = async (postId: string) => {
    await dispatch(likePost(postId, cognito_user_id_current));
    refreshPosts();
  };

  const handleCreatePost = async () => {
    if (!newPost.title || !newPost.description) {
      alert("Title and Description are required");
      return;
    }

    const formData = new FormData();
    formData.append("title", newPost.title);
    formData.append("content", newPost.description);
    formData.append("user_cognito_id", cognito_user_id_current);

    mediaFiles.forEach((file) => {
      formData.append("media", file);
    });

    await dispatch(createPost(formData));
    setModalVisible(false);
    setMediaFiles([]);
    refreshPosts();
  };

  const handleMediaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setMediaFiles(Array.from(event.target.files));
    }
  };

  return (
    <div className="blogs-container">
      {/* Create Post Button */}
      <div className="create-post-container">
        <button className="create-post-btn" onClick={() => setModalVisible(true)}>
          <FaPlus className="mr-2" /> Create Post
        </button>
      </div>

      {loading && <p>Loading...</p>}
      {error && <p className="text-red-500">{error.message}</p>}

      {/* Blog Listing */}
      <div className="blog-list">
        {posts.map((item) => (
          <div key={item.id} className="blog-card">
            {/* Header Section */}
            <div className="blog-header">
              <img
                className="blog-profile-pic"
                src={item.posted_by?.profilePic || "https://via.placeholder.com/50"}
                alt="Profile"
              />
              <div>
                <p className="blog-owner">{item.posted_by?.firstName} {item.posted_by?.lastName}</p>
                <p className="blog-date">{moment(item.created_at).format("DD MMM YYYY")}</p>
              </div>
            </div>

            {/* Post Content */}
            <p className="blog-title">{item.title}</p>
            <p className="blog-content">{item.content}</p>

            {/* Thumbnail Image */}
            {item.media?.length > 0 && (
              <div className="blog-thumbnail">
                <img
                  src={item.media[0].media_url}
                  alt="Thumbnail"
                  className="blog-thumbnail-img"
                />
              </div>
            )}

            {/* Actions Section */}
            <div className="blog-actions">
              <button className="blog-action-btn" onClick={() => handleLikePost(item.id)}>
                <FaThumbsUp className="blog-icon" /> {item.likes_count}
              </button>
              <button className="blog-action-btn">
                <FaComment className="blog-icon" /> {item.comments_count} Comments
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Create Post Modal */}
      {modalVisible && (
        <div className="modal-overlay" onClick={() => setModalVisible(false)}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={() => setModalVisible(false)}>
              <FaTimes />
            </button>
            <h2 className="modal-title">Create Post</h2>

            <div className="modal-form">
              <input
                type="text"
                placeholder="Title"
                value={newPost.title}
                onChange={(e) => dispatch(updateNewPost({ title: e.target.value }))}
                className="modal-input"
              />

              <textarea
                placeholder="Description"
                value={newPost.description}
                onChange={(e) => dispatch(updateNewPost({ description: e.target.value }))}
                className="modal-textarea"
              ></textarea>

              <input type="file" multiple onChange={handleMediaChange} className="file-input" />

              <div className="preview-container">
                {mediaFiles.map((file, index) => (
                  <img
                    key={index}
                    src={URL.createObjectURL(file)}
                    alt="preview"
                    className="preview-thumbnail"
                  />
                ))}
              </div>

              <button className="publish-btn" onClick={handleCreatePost}>
                Publish Post
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Blogs;


//-------------------good working code-------------------

// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import moment from "moment";
// import {
//   fetchPosts,
//   likePost,
//   createPost,
//   updateNewPost,
// } from "../../redux/actions/blogActions";
// import { RootState } from "../../redux/store";
// import { FaThumbsUp, FaComment, FaPlus, FaTimes } from "react-icons/fa";
// import "./Blogs.css";

// const Blogs: React.FC = () => {
//   const dispatch = useDispatch();
//   const { posts, loading, error, newPost } = useSelector(
//     (state: RootState) => state.blog
//   );

//   const cognito_user_id_current = "4d7a4f4c-e5b9-4781-8c39-0990053e8888";
//   const [modalVisible, setModalVisible] = useState<boolean>(false);
//   const [mediaFiles, setMediaFiles] = useState<File[]>([]);

//   useEffect(() => {
//     dispatch(fetchPosts());
//   }, [dispatch]);

//   const refreshPosts = () => dispatch(fetchPosts());

//   const handleLikePost = (postId: string) => {
//     dispatch(likePost(postId, cognito_user_id_current)).then(() => refreshPosts());
//   };

//   const handleCreatePost = () => {
//     if (!newPost.title || !newPost.description) {
//       alert("Title and Description are required");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("title", newPost.title);
//     formData.append("content", newPost.description);
//     formData.append("user_cognito_id", cognito_user_id_current);

//     mediaFiles.forEach((file) => {
//       formData.append("media", file);
//     });

//     dispatch(createPost(formData));
//     setModalVisible(false);
//     setMediaFiles([]);
//   };

//   const handleMediaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     if (event.target.files) {
//       setMediaFiles(Array.from(event.target.files));
//     }
//   };

//   return (
//     <div className="blogs-container">
//       {/* Create Post Button Positioned in Top-Right */}
//       <div className="create-post-container">
//         <button
//           className="create-post-btn"
//           onClick={() => setModalVisible(true)}
//         >
//           <FaPlus className="mr-2" /> Create Post
//         </button>
//       </div>

//       {loading && <p>Loading...</p>}
//       {error && <p className="text-red-500">{error.message}</p>}

//       {/* Blog Listing */}
//       <div className="blog-list">
//         {posts.map((item) => (
//           <div key={item.id} className="blog-card">
//             {/* Header Section */}
//             <div className="blog-header">
//               <img
//                 className="blog-profile-pic"
//                 src={item.posted_by?.profilePic || "https://via.placeholder.com/50"}
//                 alt="Profile"
//               />
//               <div>
//                 <p className="blog-owner">{item.posted_by?.firstName} {item.posted_by?.lastName}</p>
//                 <p className="blog-date">{moment(item.created_at).format("DD MMM YYYY")}</p>
//               </div>
//             </div>

//             {/* Post Content */}
//             <p className="blog-title">{item.title}</p>
//             <p className="blog-content">{item.content}</p>

//             {/* Thumbnail Image */}
//             {item.media?.length > 0 && (
//               <div className="blog-thumbnail">
//                 <img
//                   src={item.media[0].media_url}
//                   alt="Thumbnail"
//                   className="blog-thumbnail-img"
//                 />
//               </div>
//             )}

//             {/* Actions Section */}
//             <div className="blog-actions">
//               <button className="blog-action-btn" onClick={() => handleLikePost(item.id)}>
//                 <FaThumbsUp className="blog-icon" /> {item.likes_count}
//               </button>
//               <button className="blog-action-btn">
//                 <FaComment className="blog-icon" /> {item.comments_count} Comments
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Create Post Modal - Now Opens in an Overlay */}
//       {modalVisible && (
//         <div className="modal-overlay" onClick={() => setModalVisible(false)}>
//           <div className="modal-container" onClick={(e) => e.stopPropagation()}>
//             <button className="close-modal" onClick={() => setModalVisible(false)}>
//               <FaTimes />
//             </button>
//             <h2 className="modal-title">Create Post</h2>

//             <div className="modal-form">
//               <input
//                 type="text"
//                 placeholder="Title"
//                 value={newPost.title}
//                 onChange={(e) => dispatch(updateNewPost({ title: e.target.value }))}
//                 className="modal-input"
//               />

//               <textarea
//                 placeholder="Description"
//                 value={newPost.description}
//                 onChange={(e) => dispatch(updateNewPost({ description: e.target.value }))}
//                 className="modal-textarea"
//               ></textarea>

//               <input type="file" multiple onChange={handleMediaChange} className="file-input" />

//               <div className="preview-container">
//                 {mediaFiles.map((file, index) => (
//                   <img
//                     key={index}
//                     src={URL.createObjectURL(file)}
//                     alt="preview"
//                     className="preview-thumbnail"
//                   />
//                 ))}
//               </div>

//               <button className="publish-btn" onClick={handleCreatePost}>
//                 Publish Post
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Blogs;




